<template>
  <div :id="errorField" class="input-container">
    <textarea
      :placeholder="menuLabel"
      :value="value"
      v-bind="attrs"
      class="text-area"
      @input="$emit('input', $event.target.value)"
      v-on="listeners"
    />
  </div>
</template>
<script>
export default {
  name: 'TolTextArea',
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Boolean, Number],
      default: ''
    },
    menuLabel: {
      type: String,
      default: ''
    },
    errorField: {
      type: String,
      default: null
    }
  },
  computed: {
    attrs() {
      return this.$attrs;
    },
    listeners() {
      // eslint-disable-next-line no-unused-vars
      const { input, ...listeners } = this.$listeners;
      return listeners;
    }
  }
};
</script>
<style scoped lang="scss">
@import '../styles/colors.scss';

.input-container {
  display: flex;
  align-items: center;
  svg {
    font-size: 1.3em;
    margin-right: 10px;
  }

  input[readonly='readonly'] {
    border: 0;
  }
  .text-area {
    width: 100%;
    height: 100%;
    font-size: 0.9em;
    border: 1px solid $blue;
    padding: 8px 0;
    &:focus {
      outline: none;
    }
    &:disabled {
      background-color: $light-grey-2;
    }
  }

  &.error {
    border-bottom: 1px solid $red;
    background-color: $modified-form;
    .input-field {
      background-color: $modified-form;
    }
  }
}

@media print {
  .text-area {
    border: none;
    background-color: rgba(255, 255, 255, 0);
    padding: 0;
  }
}
</style>
